module.exports = __webpack_public_path__ + "static/assets/27956dabf33cbb1cbe46b9643e5c4f54.png";